import type { RouteRecordRaw } from 'vue-router'
import LayoutAuth from '@/views/auth/the-layout.vue'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    component: LayoutAuth,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/login/page-login.vue'),
        meta: { title: 'Masuk' },
      },
      {
        path: '/daftar',
        name: 'register',
        component: () => import('@/views/auth/register/page-register.vue'),
        meta: { title: 'Daftar' },
      },
      {
        path: '/lupa-password',
        name: 'forget password',
        component: () => import('@/views/auth/forget-password/page-forget-password.vue'),
        meta: { title: 'Lupa Password' },
      },
      {
        path: '/reset-password',
        name: 'reset password',
        component: () => import('@/views/auth/forget-password/page-reset-password.vue'),
        meta: { title: 'Ganti Password' },
      },
    ],
  },
]

export default authRoutes
